import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import config from '../config'
import { desktopAssets } from 'src/containers/PreCache'

const Wrapper = styled.div`
  width: 100%;
  position: absolute;
  top: 0;
  height: 100%;
  min-height: 100vh;
  background: url(${desktopAssets.countdownDesktopBg});
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  color: #262c65;
  overflow: hidden;

  .countdown-event-title {
    position: absolute;
    top: 6.5741%;
    left: 4.1667%;
    /* Size by height (same axis as the countdown's top offset) so the title's
       bottom edge — the gold date banner — can never overlap the countdown on
       wide/short viewports. 44.1204% = 953/2160, matching the 16:9 design. */
    height: 44.1204%;
    width: auto;
    max-width: 46.3542%;
    display: block;
    z-index: 1;
  }

  .countdown-container {
    position: absolute;
    top: 61.2963%;
    left: 3.4896%;
    width: 45.6771%;
  }

  .countdown-content {
    width: 100%;
  }

  .time-wrapper {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    column-gap: 6.2714%;
    align-items: start;

    .time-card {
      min-width: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 0.9375vw;

      .digit-row {
        width: 100%;
        display: flex;
        gap: 5.618%;
      }

      .digit {
        width: 47.191%;
        aspect-ratio: 84 / 114;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #fff;
        border: max(1px, 0.0521vw) solid #e5e7eb;
        border-radius: 0.5208vw;
        box-shadow: 0 0.1563vw 0.3125vw rgba(0, 0, 0, 0.18);
        color: #262c65;
        font-family: 'Din', 'DIN', sans-serif;
        font-size: 4.1667vw;
        font-weight: 700;
        line-height: 1;
      }

      p {
        width: 100%;
        font-family: 'Din', 'DIN', sans-serif;
        font-weight: 400;
        color: #fff;
        font-size: 1.5625vw;
        line-height: 1.2667;
        margin: 0;
        text-transform: uppercase;
        text-align: center;
      }
    }
  }
`

export default function CountdownTimer() {
  const calculateTimeLeft = () => {
    const { year, month, day, hour, minute } = config.EVENT_START_TIME
    const difference = +new Date(year, month - 1, day, hour, minute, 0, 0) - +new Date()
    let timeLeft = {}

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      }
    }

    return timeLeft
  }

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft())

  useEffect(() => {
    const timer = setTimeout(() => {
      const newTimeLeft = calculateTimeLeft()
      setTimeLeft(newTimeLeft)

      // Check if countdown has reached zero and refresh page
      if (Object.keys(newTimeLeft).length === 0) {
        window.location.reload()
      }
    }, 1000)

    // Cleanup function to clear the timer
    return () => clearTimeout(timer)
  }, [timeLeft])

  const timerComponents = []

  Object.keys(timeLeft).forEach((interval) => {
    if (isNaN(timeLeft[interval])) {
      return
    }

    const digits = String(timeLeft[interval]).padStart(2, '0')

    timerComponents.push(
      <div className="time-card" key={interval} aria-label={`${digits} ${interval}`}>
        <div className="digit-row" aria-hidden="true">
          {digits.split('').map((digit, index) => (
            <span className="digit" key={`${interval}-${index}`}>
              {digit}
            </span>
          ))}
        </div>
        <p aria-hidden="true">{interval}</p>
      </div>
    )
  })
  // const eventStarted = !timerComponents.length

  // if (eventStarted) {
  //   return <></> //Redirect to landing
  // }

  return (
    <Wrapper>
      <img
        className="countdown-event-title"
        src={desktopAssets.countdownTitle}
        alt="National Tax Conference 2026 — 26th Edition. Future-Ready Tax: Driving Trust, Transparency and Transformation"
      />
      <div className="countdown-container">
        <div className="countdown-content">
          <div className="time-wrapper">{timerComponents.length && timerComponents}</div>
        </div>
      </div>
    </Wrapper>
  )
}
